<app-layout>
  <div class="row">
    <div class="col-12" *ngIf="cari">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">{{id === '0' ? 'Yeni Cari' : 'Cari Düzenle'}}</h4>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="save()">
              Kaydet
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label" >Cari Kodu</div>
                <input [readonly]="id !== '0'" type="text" class="form-control" placeholder="Cari Kodu" [(ngModel)]="cari.cariKodu">
              </div>
              <div class="mb-3">
                <div class="form-label">Firma Unvani</div>
                <input type="text" class="form-control" placeholder="Firma Unvani" [(ngModel)]="cari.firmaUnvani">
              </div>
              <div class="mb-3">
                <div class="form-label">Yetkili Kisi</div>
                <input type="text" class="form-control" placeholder="Yetkili Kisi" [(ngModel)]="cari.yetkiliKisi">
              </div>
              <div class="mb-3">
                <div class="form-label">Mail Adresi</div>
                <input type="text" class="form-control" placeholder="Mail Adresi" [(ngModel)]="cari.mailAdresi">
              </div>
              <div class="mb-3">
                <div class="form-label">CC Mail Adresler</div>
                <input type="text" class="form-control" placeholder="CC Mail Adresler"
                  [(ngModel)]="cari.cCMailAdresler">
              </div>
              <div class="mb-3">
                <div class="form-label">Firma Adresi</div>
                <input type="text" class="form-control" placeholder="Firma Adresi" [(ngModel)]="cari.firmaAdresi">
              </div>
              <div class="mb-3">
                <div class="form-label">Şehir</div>
                <app-loading-input *ngIf="!sehirler"></app-loading-input>
                <select *ngIf="sehirler" class="form-control" [(ngModel)]="cari.sehirId"
                  [ngModelOptions]="{standalone: true}">
                  <option [value]="null" disabled selected>Şeçiniz</option>
                  <option *ngFor="let p of sehirler" [ngValue]="p.id">{{p.aciklama}}</option>
                </select>
              </div>
              <div class="mb-3">
                <div class="form-label">İlçe</div>
                <input type="text" class="form-control" placeholder="İlçe" [(ngModel)]="cari.ilce">
              </div>
            </div>
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Telefon</div>
                <input type="text" class="form-control" placeholder="Telefon" [(ngModel)]="cari.telefon">
              </div>
              <div class="mb-3">
                <div class="form-label">Cep Telefon</div>
                <input type="text" class="form-control" placeholder="Cep Telefon" [(ngModel)]="cari.cepTelefon">
              </div>
              <div class="mb-3">
                <div class="form-label">Faks</div>
                <input type="text" class="form-control" placeholder="Faks" [(ngModel)]="cari.faks">
              </div>
              <div class="mb-3">
                <div class="form-label">Vergi Dairesi</div>
                <input  [readonly]="id !== '0'" type="text" class="form-control" placeholder="Vergi Dairesi" [(ngModel)]="cari.vergiDairesi">
              </div>
              <div class="mb-3">
                <div class="form-label">Vergi No</div>
                <input  [readonly]="id !== '0'" [maxlength]="10" type="text" class="form-control" placeholder="Vergi No" [(ngModel)]="cari.vergiNo">
              </div>
              <div class="mb-3">
                <div class="form-label">TC No</div>
                <input [readonly]="id !== '0'" [maxlength] = "11"  type="text" class="form-control" placeholder="TC No" [(ngModel)]="cari.tcNo">
              </div>
              <div class="mb-3">
                <div class="form-label">IBAN No</div>
                <input type="text" class="form-control" placeholder="IBAN No" [(ngModel)]="cari.ibanNo">
              </div>
              <div class="mb-3">
                <div class="form-label">Vade</div>
                <input type="number" class="form-control" placeholder="Vade Günü" [(ngModel)]="cari.vadeGunu">
              </div>
              <div class="mb-3">
                <label class="form-check">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="cari.isFaturaKesilsin">
                  <span class="form-check-label">Talepsiz Fatura Kesilebilsin Mi?</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-layout>